import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getComponentProblems = api(async function getComponentProblems({
    projectId,
    componentId,
    componentVersion,
}) {
    return query(
        gql`
            query GetComponentProblems($projectId: String!, $componentId: String!, $componentVersion: Int!) {
                getComponentProblems(
                    projectId: $projectId
                    componentId: $componentId
                    componentVersion: $componentVersion
                )
            }
        `,
        { projectId, componentId, componentVersion },
        { returns: "getComponentProblems", fetchPolicy: "network-only" }
    )
})
